import React from "react";

function Ultilizes() {
  return (
    <div className="leverage-bg mt-5 mb-5">
      <div className="container">
        <div className="row justify-content-center align-items-center ">
          <div className="col-lg-10 col-md-12 col-sm-12 mt-5 mb-5 ">
            <h1 className="Text-heading text-center " data-aos="fade-up">
              Market-Leading IoT Solutions: Top-Tier Application Development
            </h1>
            <p className="text-center text-detail" data-aos="fade-up">
              Virtual Tech. pioneers IoT development services in Dubai and can
              help you take a futuristic approach to business growth. Our
              cutting-edge technological solutions can give you the necessary
              boost and embrace the emerging technology of IoT.
            </p>
            <div className="text-center" data-aos="fade-up">
              <button className="btn btn-experts p-3">Get in Touch</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ultilizes;
